import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { urlPath } from "../util/url.js";
export var newApi = function newApi(_ref) {
  var amsResponse = _ref.amsResponse,
    config = _ref.config;
  var translationNamespace = config.translationNamespace;
  return {
    setLocale: function () {
      var _setLocale = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var locale;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              locale = _ref2.locale;
              _context.next = 3;
              return amsResponse.getRawBody({
                method: "POST",
                path: "locale/changeLanguage",
                contentType: amsResponse.contentTypes.json,
                body: {
                  locale: locale
                }
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function setLocale(_x) {
        return _setLocale.apply(this, arguments);
      }
      return setLocale;
    }(),
    getTranslations: function () {
      var _getTranslations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
        var locale, data, translations;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              locale = _ref3.locale;
              _context2.next = 3;
              return amsResponse.getData({
                method: "GET",
                path: urlPath(_templateObject || (_templateObject = _taggedTemplateLiteral(["v1.2/translations/", "/", ""])), locale, translationNamespace)
              });
            case 3:
              data = _context2.sent;
              translations = data || [];
              return _context2.abrupt("return", translations.reduce(function (acc, _ref4) {
                var code = _ref4.code,
                  translation = _ref4.translation;
                return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, code, translation));
              }, {}));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getTranslations(_x2) {
        return _getTranslations.apply(this, arguments);
      }
      return getTranslations;
    }()
  };
};